import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/es/styles/withStyles";
import billingStyles from "./jss/BillingStyles";
import { getCreditDetails, toggleCreditDetails ,getPlans,getEmailPlans, deleteCredit, getInvoices} from "./BillingActions";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import GridContainer from "../../components/material-pro/Grid/GridContainer";
import GridItem from "../../components/material-pro/Grid/GridItem";
import FormLabel from "@material-ui/core/es/FormLabel/FormLabel";
import CreditDetailsModal from "./components/CreditDetailsModal";
import { Elements, StripeProvider } from "react-stripe-elements";
import { Translate } from "react-redux-i18n";
import SubscribeModal from './components/SubscribeModal';
import {openConfirmationModal} from "../../components/confirmation-modal/ConfirmationModalActions";
import BillingForm from './components/BillingForm';
import EditInfo from './components/edit-info/EditInfo';
import { closeInfoModal, openInfoModal } from './components/edit-info/EditInfoActions'
import InvoicesTable from './components/InvoicesTable'
import BillingContainer from './components/BillingContainer';
import Trial from '../../components/Trial'
import { changePageHeader } from "../app/AppActions";

class Billing extends Component {

    state = {
        stripe: null
    };

    componentWillMount() {
        this.props.getCreditDetails();
        this.props.getInvoices();
        this.props.changePageHeader('Billing')
        // this.props.toggleCreditDetails()
    }

    componentWillReceiveProps(nextProps) {
        const { app, billing, getCreditDetails, closeInfoModal } = nextProps;

        if (billing.needUpdate) {
            getCreditDetails();
            closeInfoModal()
            this.props.getPlans();
            this.props.getEmailPlans();
            this.props.getInvoices()
        }
        if (!app.fetching && !billing.fetching && app.stripe.stripePublishableKey) {
            if (window.Stripe) {
                this.setState({ stripe: window.Stripe(app.stripe.stripePublishableKey) })
            } else {
                const stripeScript = document.getElementById('stripeScript');
                stripeScript.addEventListener('load', () => {
                    this.setState({ stripe: window.Stripe(app.stripe.stripePublishableKey) });
                });
            }
        }
    }

    handlePaymentDetails = (text) => {
        this.props.openInfoModal({
            content: <StripeProvider stripe={this.state.stripe}>
            <Elements>
                <BillingForm />
            </Elements>
        </StripeProvider>,
        text: text
        })
    }

    toggleDeleteHandler = () => {
        const { openConfirmationModal, deleteCredit, billing: { customer: { last4Digits } } } = this.props;
        openConfirmationModal({text: <div>Are you sure you want to delete credit detailes</div>, callback: () => deleteCredit(last4Digits), confirmCheckbox: false, btn1: 'Cancel', btn2: 'Confirm'})
    }

    renderLabelAndText = (label, text) => {
        const { classes } = this.props;
        return (
            <GridContainer className={classes.labelAndText}>
                <GridItem xs={12} sm={3}>
                    <FormLabel>
                        {label}:
                    </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={9}>{text}</GridItem>
            </GridContainer>
            );
    };

    renderBody = () => {
        const { billing, app, toggleCreditDetails, classes } = this.props;
        if (app.fetching || billing.fetching) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress size={45} />
                </div>);
        }
        if (!app.stripe.enabled) {
            return (<strong><Translate value="billing.billingNotEnabledForDomain" /></strong>);
        }
        return <BillingContainer handlePaymentDetails={this.handlePaymentDetails} />
    };

    renderBody2 = (env) => {
        const { app } = this.props;
        return (
            <div>
                {app.stripe.enabled &&
                <StripeProvider stripe={this.state.stripe}>
                <Elements>
                    <SubscribeModal env={env}></SubscribeModal>
                </Elements>
                </StripeProvider>}
            </div>
        )
    }

    render() {
        const { classes, app, billing: { openCreditDetails, invoicesContent } } = this.props;
        return (
            app && app.env === 'production' || app.env === 'Production' || app.env === "staging" ? 
            <Trial routeName="Billing" />
            :
            <div>
                {this.renderBody()}
                {app.stripe.enabled && this.state.stripe &&
                    <StripeProvider stripe={this.state.stripe}>
                        <Elements>
                            <CreditDetailsModal open={openCreditDetails} />
                        </Elements>
                    </StripeProvider>}
                {invoicesContent && invoicesContent.length > 0 && <div className={classes.pageTitle}>
                    Billing History
                </div>}
                <InvoicesTable />
                <p>Subscribe beta</p>
                {this.renderBody2(app.env)}
                <EditInfo />
            </div>
        );
    }
}

const mapStateToProps = ({ app, billing }) => ({ app, billing });

const mapDispatchToProps = dispatch => bindActionCreators({ getCreditDetails, toggleCreditDetails, getPlans, getInvoices, deleteCredit, getEmailPlans, openConfirmationModal, openInfoModal, closeInfoModal, changePageHeader }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(billingStyles)(Billing));



// WEBPACK FOOTER //
// ./src/containers/billing/Billing.js